/**
 * SYNCED FROM SERVER — do not edit by hand.
 *
 * Source: `server/src/api/<domain>/<domain>.contract.ts` (or the
 * shared bases under `server/src/api/common/contracts/`).
 *
 * Regenerate: `cd api-client && bun run sync:contracts`.
 *
 * The server is the source of truth for contract definitions. This
 * file exists so the web SPA can import zod schemas + oRPC contract
 * types from `@event-manager/api-client/contracts/<domain>.contract`
 * without reaching into the server workspace.
 */

import { z } from "zod";

export const EventStatusSlugSchema = z
	.string()
	.min(1)
	.max(64)
	.regex(/^[A-Z][A-Z0-9_]*$/);

export const EventStatusDefinitionSchema = z.object({
	id: z.string(),
	orgId: z.string(),
	slug: EventStatusSlugSchema,
	label: z.string().min(1).max(80),
	color: z.string().regex(/^#[0-9a-fA-F]{6}$/),
	position: z.number().int().min(0),
	isActive: z.boolean(),
	isSystem: z.boolean(),
	createdAt: z.string().datetime(),
	updatedAt: z.string().datetime(),
	deletedAt: z.string().datetime().nullable(),
});

export type EventStatusDefinition = z.infer<typeof EventStatusDefinitionSchema>;

export const DEFAULT_EVENT_STATUS_DEFINITIONS = [
	{ slug: "CONFIRMED", label: "Confirmed", color: "#22c55e", position: 0 },
	{ slug: "COMPLETED", label: "Completed", color: "#3b82f6", position: 1 },
	{ slug: "NO_SHOW", label: "No-show", color: "#ef4444", position: 2 },
] as const;

export const PROTECTED_EVENT_STATUS_SLUGS = new Set<string>(
	DEFAULT_EVENT_STATUS_DEFINITIONS.map((status) => status.slug)
);
